export default {
  INCORRECT_PASSCODE: "Incorrect Passcode",
  MEMBER_DOES_NOT_EXIST_FOR_ID: "Member does not exist for given member id",
  INVALID_TOKEN: "Invalid token",
  EXPIRED_TOKEN: "Expired token",
  ORG_DOES_NOT_EXIST_FOR_NAME: "Org does not exist for the given org name",
  APP_NOT_EXISTS_FOR_ID: "App does not exist for given app id",
  MEMBER_NOT_EXISTS_FOR_ID_AND_ORG_NAME:
    "Member does not exist for given org member id and org name",
  MEMBERS_NOT_EXISTS_FOR_ID_AND_ORG_NAME:
    "Members does not exist for given org member id and org name",
  MEMBER_APP_KEY_PAIR_ALREADY_EXISTS: "MemberApp key pair already exists",
  MEMBER_DEACTIVATED: "Member has been deactivated by Admin",
  INVALID_CREDENTIALS: "Invalid Credentials",
  MEMBER_APP_NOT_EXISTS_FOR_AUTH_TOKEN:
    "MemberApp doesn't exist for given auth token",
  MEMBER_NOT_EXISTS_FOR_MEMBER_APP: "Member doesn't exist for given memberApp",
  GROUP_NOT_EXISTS_FOR_ID: "Group does not exist for the given group id",
  MEMBER_NOT_LINKED_WITH_GROUP_ID:
    "Member is not linked with the given group id",
  MEMBER_NOT_LINKED_WITH_GROUP: "Member is not linked with the given group",
  NOT_PARTICIPANT_OF_GROUP: "You are not the participant of the given group",
  MEMBER_EXISTS_IN_GROUP: "Given member id already exists in the group",
  MEMBER_NOT_EXISTS_IN_GROUP: "Given member id does not exist in the group",
  MEMBER_TO_REMOVE_NOT_EXISTS:
    "Member whom you want to remove does not exist for the given member id", //
  CANNOT_JOIN_GROUP_NOT_PUBLIC:
    "Given group is not public group. You cannot join this group",
  INCORRECT_PASSPHRASE: "Incorrect Passphrase",
  WRONG_ANSWERS_ENTERED: "One or more invalid answers",
  MINIMUM_THREE_ANSWERS_NEEDED: "Minimum three answers needed",
  DUPLICATE_ENTRY: "Tried to create duplicate entry",
  APP_NOT_LINKED:
    "App is not linked. Login to the Admin Panel/App and link the app",
  INVALID_SECRET: "Invalid App Secret",
  DUPLICATE_ORG_ENTRY: "Org with the given name already exists",
  DUPLICATE_MEMBER_ENTRY:
    "Member with the given memberId already exists in the org",
  GROUP_ID_NOT_BELONGS_TO_PUBLIC_GROUP:
    "Given groupId does not correspond to a public group",
  INVALID_LMS_APP_SECRET_KEY: "Invalid LMS App Secret Key",
  MEMBER_APPROVAL_IS_PENDING: "Member Approval is Pending",
  INCORRECT_SECRET: "Incorrect Secret",
  MEMBER_AUTHORIZATION_IS_PENDING: "Member Authorization is Pending",
  // LMS /memberInfo when member auth is pending (user-facing copy from server)
  ACCOUNT_PENDING_AUTHORIZATION:
    "Account Pending Authorization. Wait for the application service to authorize, and then try logging in again",
  EMPLOYEE_AUTHORIZATION_IS_PENDING: "Employee Authorization is Pending",
  MEMBER_APP_APPROVAL_IS_PENDING: "Member App Approval is Pending",
  INVALID_SERVER_PUBLIC_KEY: "Invalid Server Public Key",
  INVALID_APP_ID: "Invalid App Id",
  ERROR_ORG_OR_MEMBER_OR_MEMBERAPP_ALREADY_EXIST:
    "Org or member or member app already exist",
  ERROR_TOKEN_NOT_FOUND: "Token not found",
  USER_DOSE_NOT_EXIST: "User does not exist for given email",
  INVALID_ORG_OR_MEMBER_NAME: "Invalid org or member name",
  ORG_APP_NOT_APPROVED: "Org App Approval is Pending",
  APP_NOT_EXIST_FOR_ORG: "App is not linked to the Org. Try to Register your account with the App and wait for an Admin to approve",
  RE_REGISTER: "Re-Register",
  USER_REGISTRATION_PENDING: "User registration pending",
  APP_DOES_NOT_HAVE_THE_CORRECT_ROLE:
    "App does not have permission to create a new Org. Check with your admin or the app-provider",
  ORG_CREATION_APP_KEY_PAIR_ID_REQUIRED:
    "orgCreationAppKeyPairId is required and cannot be null or empty",
  INVALID_KEY_PAIR_ID: "Invalid key pair id",
  AUTO_APPROVED_MEMBER_ACCESS_DENIED:
    "Auto-approved members do not have access to this operation, ask your admin to approve you",
  MEMBER_NOT_APPROVED_YET: "Account registered, but not approved yet. Wait for your admin to approve and try logging in (do not register again)",
  MEMBER_ALREADY_EXISTS: "Member already exists",
  MEMBER_ALREADY_EXISTS_FOR_A_DIFFERENT_EMAIL_ADDRESS: "Member already exists for a different email address",
  ORGANIZATION_ALREADY_EXISTS: "An organization with this name already exists.",
  REGISTRATION_INCOMPLETE: "Registration Incomplete",
  ERROR_USER_HAVE_NO_ACTIVE_MEMBERS: "User have no active members",
  USER_RECOVERY_ALREADY_IN_PROGRESS: "User recovery already in progress",
  USER_HAS_DEVELOPER_ACCOUNT_DURING_RECOVERY:
    "User has a developer account and cannot continue recovery",
  CANNOT_LINK_DEVELOPER_ACCOUNT_DURING_RECOVERY:
    "Cannot link a developer account to a user in recovery",
  RE_AUTHENTICATE: "Re-Authenticate",
  INVALID_KEY_PAIR: "Invalid App Key Pair",
  MEMBER_APP_NOT_EXIST_FOR_ID:
    "Member app doesn't exist for the given memberAppId",
  MEMBER_PUBLIC_KEY_NOT_EXISTS: "Member public key does not exist",
  USER_NOT_ASSOCIATED_WITH_MEMBER:
    "No user associated with the given memberAppId",
  MEMBER_LOCK_BOX_NOT_FOUND_FOR_MEMBER: "Member Lock Box Not Found For Member",
  MEMBER_CREATION_APP_KEY_PAIR_ID_REQUIRED:
    "memberCreationAppKeyPairId is required and cannot be null or empty",
  ACCESS_APP_KEY_PAIR_ID_REQUIRED:
    "accessAppKeyPairId is required and cannot be null or empty",
};
